"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            var nextAction = next(action);
            if (window) {
                window._state = getState();
            }
            return nextAction;
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/store/addStateToWindowMiddleware.js
// module id = 2047
// module chunks = 0